
























































import { Component, Vue } from "vue-property-decorator";
import {
  ReferralInfo,
  Invitee as IInvitee,
  InviteReward
} from "@foxone/api/src/models/foxone";
import { State } from "vuex-class";
import ViewInviteRewardModal from "./ViewInviteRewardModal.vue";

@Component({
  components: {
    ViewInviteRewardModal
  }
})
class Invitee extends Vue {
  @State(state => state.basis.account.referral) referral!: ReferralInfo;

  claiming = false;

  get invitees() {
    return this.referral.invitees || [];
  }

  get empty() {
    return this.invitees.length === 0;
  }

  getInviteeMeta(invitee: IInvitee) {
    const reward = invitee.reward;
    return {
      name: invitee.fullname,
      avatar: invitee.avatar || require("@/assets/images/default_avatar.png"),
      time: this.$common.utils.date.formatDate(invitee.created_at),
      canClaim: reward && !reward.is_claimed,
      hasReward: Boolean(reward),
      claimed: reward && reward.is_claimed
    };
  }

  async handleClaim(reward: InviteReward) {
    this.claiming = true;
    try {
      await this.$api.foxone.claimReward(reward.id);
      await this.$store.dispatch("basis/account/loadAccountData");
      this.$common.utils.helper.toast(this, {
        message: this.$t("invite.mine.claim.success") as string,
        color: "success"
      });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.claiming = false;
  }
}
export default Invitee;
